import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

import ImportStep1 from "../Components/ImportData/ImportStep1";
import ImportStep2 from "../Components/ImportData/ImportStep2";
import { Button, Container, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { appendable_columns } from "../static/brands_wholesalers_data";
import { AI_BACKEND_API, API_URL, API_TOKEN } from "../Config/secrets";
import { uploadFileToBucket } from "../Utils";

const ImportData = () => {
  const navigate = useNavigate();
  const { type } = useParams();
  const [step, setStep] = useState(1);
  const [file, setFile] = useState();
  const [tableData, setTableData] = useState();
  const [appendableColumns, setAppendableColumns] = useState(appendable_columns);

  const [loading, setLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [uploadWarning, setUploadWarning] = useState();

  // Source management state
  const [sources, setSources] = useState([]);
  const [loadingSources, setLoadingSources] = useState(false);
  const [selectedSourceId, setSelectedSourceId] = useState(null);
  const [showAddSource, setShowAddSource] = useState(false);
  const [newSourceName, setNewSourceName] = useState('');
  const [newSourceLogo, setNewSourceLogo] = useState('');
  const [addingSource, setAddingSource] = useState(false);

  const _toggleSuccessModal = () => setSuccessModal((prev) => !prev);

  const fetchSources = useCallback(async () => {
    setLoadingSources(true);
    try {
      const response = await axios.get(`${API_URL}/auth/get-sources`, {
        headers: { Authorization: API_TOKEN }
      });
      if (response?.data?.statusCode === 200) {
        setSources(response.data.data || []);
      }
    } catch (error) {
      console.error('Error fetching sources:', error);
    } finally {
      setLoadingSources(false);
    }
  }, []);

  useEffect(() => {
    fetchSources();
  }, []);

  const handleAddSource = async () => {
    if (!newSourceName.trim()) {
      toast.error('Source name is required');
      return;
    }
    setAddingSource(true);
    try {
      const response = await axios.post(
        `${API_URL}/auth/add-source`,
        { name: newSourceName.trim(), logo: newSourceLogo.trim() || null },
        { headers: { Authorization: API_TOKEN } }
      );
      if (response?.data?.statusCode === 200) {
        toast.success('Source added successfully');
        setSources((prev) => [...prev, response.data.data]);
        setSelectedSourceId(response.data.data.id);
        setNewSourceName('');
        setNewSourceLogo('');
        setShowAddSource(false);
      }
    } catch (error) {
      toast.error('Failed to add source');
      console.error('Error adding source:', error);
    } finally {
      setAddingSource(false);
    }
  };

  const _handleTableColumnSelect = (selectedColumn, appendedValue) => {
    // Make a copy of the current state
    const updatedData = { ...tableData };

    // Find the index of the selected column in the columns array
    const columnIndex = updatedData?.columns?.findIndex((column) => column?.Header === selectedColumn);

    // If the column is found, add the appendedValue property
    if (columnIndex !== -1) {
      updatedData.columns[columnIndex] = {
        ...updatedData?.columns[columnIndex],
        appendedValue,
      };
      console.log(selectedColumn, appendedValue)
      // Update the state with the new data
      setTableData(updatedData);
      setAppendableColumns((prev) => prev?.filter((c) => c.id !== appendedValue));
    } else {
      console.error(`Column with Header "${selectedColumn}" not found.`);
    }
  };

  const _handleTableColumnUnSelect = (selectedColumn) => {
    // Make a copy of the current state
    const updatedData = { ...tableData };

    // Find the index of the selected column in the columns array
    const columnIndex = updatedData?.columns.findIndex((column) => column?.Header === selectedColumn);

    // If the column is found, add the appendedValue property
    if (columnIndex !== -1) {
      const appendedValue = updatedData?.columns[columnIndex].appendedValue;
      updatedData.columns[columnIndex] = {
        Header: updatedData.columns[columnIndex].Header,
        accessor: updatedData.columns[columnIndex].accessor,
      };

      // Update the state with the new data
      setTableData(updatedData);

      const appendableColumn = appendable_columns?.find((c) => c.id === appendedValue);

      setAppendableColumns((prev) => [...prev, appendableColumn]);
    } else {
      console.error(`Column with Header "${selectedColumn}" not found.`);
    }
  };
  const _handleTableDataRemove = () => {
    setAppendableColumns(appendable_columns);
    setFile(null);
    setTableData(null);
    setStep(1);
  };

  const validateData = () => {
    const requiredFieldsString = appendableColumns
      .reduce((accumulator, currentValue) => {
        if (currentValue.required) {
          accumulator?.push(currentValue.label);
        }
        return accumulator;
      }, [])
      .join(", ");

    if (requiredFieldsString) {
      toast.warning(`${requiredFieldsString} ${requiredFieldsString?.includes(",") ? "fields are" : "field is"} required!`);
      return false;
    }

    if (!selectedSourceId) {
      toast.warning('Please select a source');
      return false;
    }

    return true;
  };

  const _handleSubmit = async () => {
    // if (!type) return toast.info("Please select type first!")

    // Checking if all our appenable columns are appended to data
    if (!validateData()) {
      return;
    }

    setLoading(true);

    const url = await uploadFileToBucket(`files-uploaded`, file);

    const payload = {
      file_link: url,
      admin: true,
      file_type: file?.type?.includes('csv') ? 'csv' : 'xlsx',
      source_id: selectedSourceId,
      source: 'admin',
      columns: tableData?.columns?.map((c) => ({
        Header: c?.appendedValue || c?.Header,
        accessor: c?.accessor,
      })),
    };
    const response = await axios.post(type === 'brand' ? `${AI_BACKEND_API}/profiling_brand` : `${AI_BACKEND_API}/profiling_retailer`, payload);

    if (response?.data?.status === 200) {
      navigate(-1)
      toast.success('We have received your data and its been  queed you will get email once its processed')
      if (response?.data?.warning) {
        // setUploadWarning(response?.data?.warning);
      }
      // _toggleSuccessModal();
    }

    setLoading(false);
  };

  const onClose = () => {
    _toggleSuccessModal();
    navigate(-1)
  }

  return (
    <div
      style={{
        padding: '20px 0px',
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        overflowX: "hidden",
      }}
    >
      <div style={{ paddingInline: "2rem" }}>
        <h1 style={{ fontSize: "30px", fontWeight: "bold" }}>
          Upload a file
        </h1>
        <p
          style={{
            color: "#999",
            fontSize: "13px",
          }}
        >
          Upload a file. This is particularly
          useful when you have a large number of contacts to import.
        </p>
      </div>

      <hr style={{ backgroundColor: "#CFCFCF", width: "100%", zIndex: -1 }} />

      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowX: "hidden",
        }}
      >
        <ImportStep1
          step={step}
          file={file}
          onFileAdd={setFile}
          tableData={tableData}
          onStepChange={(s) => step !== s && s >= 0 && setStep(s)}
          onTableDataAdd={setTableData}
          onTableDataRemove={_handleTableDataRemove}
        />

        <hr style={{ backgroundColor: "#CFCFCF", marginInline: "-1rem" }} />

        <ImportStep2
          step={step}
          loading={loading}
          tableData={tableData}
          onStepChange={(s) => step !== s && s >= 0 && setStep(s)}
          onSubmit={_handleSubmit}
          appendableColumns={appendableColumns}
          setAppendableColumns={setAppendableColumns}
          onTableColumnSelect={_handleTableColumnSelect}
          onTableColumnUnSelect={_handleTableColumnUnSelect}
          sources={sources}
          loadingSources={loadingSources}
          selectedSourceId={selectedSourceId}
          onSourceChange={setSelectedSourceId}
          showAddSource={showAddSource}
          onShowAddSourceChange={setShowAddSource}
          newSourceName={newSourceName}
          onNewSourceNameChange={setNewSourceName}
          newSourceLogo={newSourceLogo}
          onNewSourceLogoChange={setNewSourceLogo}
          addingSource={addingSource}
          onAddSource={handleAddSource}
        />
      </Container>

      <Modal isOpen={successModal} toggle={onClose}>
        <ModalHeader toggle={onClose}>
          {"Upload Successful"}
        </ModalHeader>
        <ModalBody>
          {uploadWarning ||
            "Your file was successfully uploaded."}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ImportData;
